/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { withNoTranslate } from "i18n/noTranslate";
import { TimezoneDisplay } from "i18n/timezone";
import React, { FC } from "react";
import { Link } from "react-router-dom";

export const PortalTopEventCard: FC<{
  href: string;
  tag: string;
  tagColor: string;
  thumbnail: string;
  date: string;
  time?: string;
  title: string;
}> = ({ href, tag, tagColor, thumbnail, date, time, title }) => {
  const classes = styles({
    tagColor,
  });

  return (
    <article css={classes.item}>
      <Link to={href}>
        <div css={classes.thumbnail}>
          <p className="tag">{tag}</p>
          <img src={thumbnail} alt={title} />
        </div>

        <div css={classes.info}>
          <div css={classes.datetime}>
            <p className="date">{date}</p>
            {time && <p>OPEN {time}</p>}
            <TimezoneDisplay />
          </div>
          <h3 {...withNoTranslate({ className: "title" })}>{title}</h3>
        </div>
      </Link>
    </article>
  );
};

export const PortalTopExternalGoodsCard: FC<{
  href: string;
  tag: string;
  tagColor: string;
  thumbnail: string;
  date: string;
  time?: string;
  title: string;
}> = ({ href, tag, tagColor, thumbnail, date, time, title }) => {
  const classes = styles({
    tagColor,
  });

  return (
    <article css={classes.item}>
      <a href={href} target="_blank" rel="noopener noreferrer">
        <div css={classes.thumbnail}>
          <p className="tag">{tag}</p>
          <img src={thumbnail} alt={title} />
        </div>

        <div css={classes.info}>
          <div css={classes.datetime}>
            <p className="date">{date}</p>
            {time && <p>OPEN {time}</p>}
            <TimezoneDisplay />
          </div>
          <h3 {...withNoTranslate({ className: "title" })}>{title}</h3>
        </div>
      </a>
    </article>
  );
};

const styles = ({ tagColor }: { tagColor: string }) => {
  return {
    item: css`
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;
    `,
    thumbnail: css`
      position: relative;
      .tag {
        position: absolute;
        top: 0;
        right: 0;
        padding: 4px 10px;
        color: ${tagColor};
        font-size: 14px;
        font-weight: bold;
        background-color: rgba(0, 0, 0, 0.7);
      }
      img {
        width: 100%;
      }
    `,
    info: css`
      padding: 16px;
      @media screen and (min-width: 768px) {
        padding: 16px 16px 32px;
      }
      font-weight: bold;
      .title {
        line-height: 1.5em;
      }
    `,
    datetime: css`
      margin-bottom: 12px;
      @media screen and (min-width: 768px) {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
      }
      .date {
        margin-bottom: 8px;
        @media screen and (min-width: 768px) {
          margin-right: 8px;
          margin-bottom: 0px;
        }
      }
    `,
  };
};
